import React from 'react';
import './LegalDocument.css';

/**
 * Document légal générique (CGU, confidentialité, mentions…).
 * Props :
 * - meta: { title, version, effectiveDate, publisher, support? }
 * - sections: [{ id, title, paragraphs: string[] }]
 * - annexe?: { title, note?, rows: [label, value][] }
 * - acceptance?: { title, paragraphs: string[] } | null
 * - compact?: boolean
 */
export default function LegalDocument({
  meta,
  sections = [],
  annexe = null,
  acceptance = null,
  compact = false,
}) {
  if (!meta) return null;

  return (
    <article className={`legal-doc${compact ? ' legal-doc--compact' : ''}`}>
      <header className="legal-doc__header">
        <p className="legal-doc__brand">{meta.publisher}</p>
        <h1 className="legal-doc__title">{meta.title}</h1>
        <p className="legal-doc__meta">
          Version {meta.version} — En vigueur depuis le {meta.effectiveDate}
        </p>
      </header>

      <div className="legal-doc__body">
        {sections.map((section) => (
          <section key={section.id} id={section.id} className="legal-doc__section">
            <h2>{section.title}</h2>
            {section.paragraphs.map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </section>
        ))}

        {annexe && (
          <section className="legal-doc__section legal-doc__annexe">
            <h2>{annexe.title}</h2>
            {annexe.note && <p className="legal-doc__note">{annexe.note}</p>}
            {annexe.rows?.length > 0 && (
              <table className="legal-doc__table">
                <tbody>
                  {annexe.rows.map(([label, value]) => (
                    <tr key={label}>
                      <th scope="row">{label}</th>
                      <td>{value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </section>
        )}

        {acceptance && (
          <section className="legal-doc__section legal-doc__acceptance">
            <h2>{acceptance.title || 'Acceptation'}</h2>
            {(acceptance.paragraphs || []).map((text, index) => (
              <p key={index}>{text}</p>
            ))}
            {meta.support && (
              <p className="legal-doc__contact">
                Questions : <a href={`mailto:${meta.support}`}>{meta.support}</a>
              </p>
            )}
          </section>
        )}

        {!acceptance && meta.support && (
          <p className="legal-doc__contact">
            Contact : <a href={`mailto:${meta.support}`}>{meta.support}</a>
          </p>
        )}
      </div>
    </article>
  );
}
